var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Info } from 'shared/assets/icons';
import { Box, Flex, Icon, Text } from 'shared/components';
export var RequiredNoteTypeWarning = function () {
    return (_jsx(Box, __assign({ backgroundColor: "blue.100", color: "blue.500", padding: 3, mb: 3 }, { children: _jsxs(Flex, __assign({ flexDir: "row" }, { children: [_jsx(Icon, { as: Info, mr: 3, boxSize: 4 }), _jsx(Text, __assign({ "data-testid": "selectNoteText", size: "body2" }, { children: "Select a note template above to start your documentation" }))] })) })));
};
